module.exports = __webpack_public_path__ + "img/icon-pay-success-v2.05d4965.png";